import {formatNumber} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React from 'react';
import {useTheme} from 'styled-components/native';
import InnerCircleText from '../InnerCircleText';

export interface OlympusInnerCircleProps {
  tierCredits: number;
}

const OlympusInnerCircle: React.FC<OlympusInnerCircleProps> = ({
  tierCredits,
}) => {
  const theme = useTheme() as any;
  const {white} = theme.colors;

  return (
    <View justifyContent="center" alignItems="center">
      <Text
        fontFamily="heading"
        fontSize="18px"
        fontWeight="bold"
        lineHeight="25px"
        color={white}
        pb="4px">
        {tierCredits ? formatNumber(tierCredits) : 0}
      </Text>
      <InnerCircleText text="Tier Credits" isSevenStars={true} />
    </View>
  );
};

export default OlympusInnerCircle;
